const sumArrays = (array1, array2) => {
  return array1.map((value, index) => value + array2[index]);
};

export default sumArrays;
